import ProfilePage from "./profile.page";

export default ProfilePage;